import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Breadcrumb from '@/components/tools/Breadcrumb';
export default {
  name: "PageHeader",
  components: {
    "s-breadcrumb": Breadcrumb
  },
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    breadcrumb: {
      type: Array,
      default: null,
      required: false
    },
    logo: {
      type: String,
      default: '',
      required: false
    },
    avatar: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {
      name: '',
      breadList: []
    };
  },
  created: function created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb: function getBreadcrumb() {
      var _this = this;

      this.breadList = []; // this.breadList.push({name: 'index', path: '/dashboard/', meta: {title: '首页'}})

      this.name = this.$route.name;
      this.$route.matched.forEach(function (item) {
        // item.name !== 'index' && this.breadList.push(item)
        _this.breadList.push(item);
      });
    }
  },
  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  }
};